import { Form, Input, Select, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import parkService from '../../../../services/config/park.service';

const AddTicketTypeModal = ({ form, }) => {
    const [parks, setParks] = useState([]);
    const has_multi_park = Form.useWatch('has_multi_park', form);

    useEffect(() => {
        const fetchParks = async () => {
            const parkResponse = await parkService?.getPark();
            setParks(parkResponse?.parks ?? []);
        };
        fetchParks();
    }, []);

    return (
        <>
            <Form.Item label={'Name'} name={'name'}>
                <Input />
            </Form.Item>
            <Form.Item label={'Multi Park'} name={'has_multi_park'} valuePropName='checked'>
                <Switch />
            </Form.Item>
            {has_multi_park && (
                <Form.Item label={'Parks'} name={'park_ids'}>
                    <Select
                    mode='multiple'
                    placeholder='Select parks'
                    options={parks?.map(park => ({ label: park?.name, value: park?.park_id }))}
                    />
                </Form.Item>
            )}
        </>
    );
}

export default AddTicketTypeModal;